import { Directive, Output, EventEmitter, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[ldsClickOutSide]',
    standalone: false
})
export class ClickOutSideDirective {

  constructor(private _elementRef: ElementRef) { }

  @Output('ldsClickOutSide') ldsClickOutSide: EventEmitter<any> = new EventEmitter();

  @HostListener('document:click', ['$event.target']) onMouseEnter(targetElement) {
    const clickedInside = this._elementRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.ldsClickOutSide.emit(null);
    }
  }
}
